import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaDateGroup, WeaLocaleProvider } from "ecCom";

const getLabel = WeaLocaleProvider.getLabel;

@observer
export default class DateGroupItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    let datas = [
      { value: "0", name: getLabel(332, "全部") },
      { value: "1", name: getLabel(15537, "今天") },
      { value: "2", name: getLabel(15539, "本周") },
      { value: "3", name: getLabel(15541, "本月") },
      { value: "4", name: getLabel(21904, "本季") },
      { value: "5", name: getLabel(15384, "本年") },
      { value: "7", name: getLabel(27347, "上个月") },
      { value: "8", name: getLabel(81716, "上一年") },
      { value: "6", name: getLabel(32530, "指定日期范围") }
    ];
    if (c.options && c.options.length > 0) {
      datas = [];
      c.options.forEach(o => {
        datas.push({
          value: o.key,
          name: o.showname
        });
      });
    }
    return (
      <WeaDateGroup
        {...bindObj.bind()}
        value={toJS(bindObj.value)}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
        isMobx
        datas={datas}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/DateGroupItem.js